export function isEditableTarget(element) {
	if (!element || typeof element !== "object") {
		return false;
	}

	const tag = element.tagName;
	if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") {
		return true;
	}

	return Boolean(element.isContentEditable);
}
